import CardBody from '@/components/ui/cards/CardBody';
import CardHeader from '@/components/ui/cards/CardHeader';
import { Input } from '@/components/ui/inputs/input';
import { InputSelect } from '@/components/ui/inputs/input-select';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import { getPaymentBySlugService, updatePaymentService } from '@/services/PaymentService';
import PermissionCheck from '@/components/common/PermissionCheck';

const EdahabPayTab = ({ className }) => {
    const edahabModeList = [
        { value: '1', label: 'Live' },
        { value: '0', label: 'Sandbox' },
    ];
    const edahabStatus = [
        { value: 1, label: 'Enable' },
        { value: 2, label: 'Disable' },
    ];
    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);

    useEffect(() => {
        getEdahabPayDetails();
    }, [dispatch, reset]);

    const getEdahabPayDetails = () => {
        dispatch(getPaymentBySlugService('edahab'))
            .then((res) => {
                const edahabData = res?.data?.data?.[0];
                const gatewayOptions = Array.isArray(edahabData?.gateway_options) ? edahabData.gateway_options : [];
                reset({
                    edahab_id: edahabData?._id || '',
                    status: edahabData?.status ?? 1,
                    edahab_api_key: gatewayOptions.find((option) => option?.option === 'edahab_api_key')?.value ?? '',
                    edahab_secret_key: gatewayOptions.find((option) => option?.option === 'edahab_secret_key')?.value ?? '',
                    edahab_agent_code: gatewayOptions.find((option) => option?.option === 'edahab_agent_code')?.value ?? '',
                    edahab_mobile_number: gatewayOptions.find((option) => option?.option === 'edahab_mobile_number')?.value ?? '',
                    edahab_mode: String(
                        gatewayOptions.find((option) => option?.option === 'edahab_mode')?.value ?? '1',
                    ),
                });
            })
            .catch(({ message, errorData }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        const dataToSend = {
            id: data?.edahab_id,
            status: data?.status,
            options: [
                {
                    option: 'edahab_api_key',
                    value: data?.edahab_api_key,
                },
                {
                    option: 'edahab_secret_key',
                    value: data?.edahab_secret_key,
                },
                {
                    option: 'edahab_agent_code',
                    value: data?.edahab_agent_code,
                },
                {
                    option: 'edahab_mobile_number',
                    value: data?.edahab_mobile_number,
                },
                {
                    option: 'edahab_mode',
                    value: data?.edahab_mode,
                },
            ],
        };
        dispatch(updatePaymentService(dataToSend))
            .then((res) => {
                setIsFormSumbmit(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };
    return (
        <>
            <CardHeader isBorder={true}>
                <h3 className="db-card-title">Edahab Pay</h3>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input type="hidden" {...register('edahab_id')} />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="edahab_api_key"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Api Key'}
                                    type="text"
                                    id="edahab_api_key"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.edahab_api_key?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="edahab_secret_key"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Secret Key'}
                                    type="text"
                                    id="edahab_secret_key"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.edahab_secret_key?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="edahab_agent_code"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Agent Code'}
                                    type="text"
                                    id="edahab_agent_code"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.edahab_agent_code?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="edahab_mobile_number"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mobile Number'}
                                    type="text"
                                    id="edahab_mobile_number"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.edahab_mobile_number?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="edahab_mode"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'edahab_mode'}
                                    labelText={'Mode'}
                                    value={edahabModeList.find((data) => data.value === String(field.value)) || null}
                                    onChange={(option) => field.onChange(option?.value ?? '')}
                                    options={edahabModeList}
                                    errorType={errors?.edahab_mode?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="status"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'status'}
                                    labelText={'Status'}
                                    value={edahabStatus.find((data) => data.value === field.value) || null}
                                    onChange={(option) => field.onChange(option?.value ?? 1)}
                                    options={edahabStatus}
                                    errorType={errors?.status?.type}
                                />
                            )}
                        />
                        <PermissionCheck permsission={'update_settings'}>
                            <div className="sm:col-span-2">
                                <button type="submit" className="db-btn text-white bg-primary">
                                    <i className="lab lab-save"></i>
                                    <span>Save</span>
                                </button>
                            </div>
                        </PermissionCheck>
                    </div>
                </form>
            </CardBody>
        </>
    );
};

export default EdahabPayTab;
